import { Component, Inject, Input, OnInit } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogRef,
  MatDialogTitle,
  MatDialogContent,
  MatDialogActions
} from '@angular/material/dialog';
import { Form, ReactiveFormsModule, FormsModule } from '@angular/forms';
import moment from 'moment';
import { HireItemService } from '../..';
import { DepotLocation, Item, Product } from '../../../models';
import { ConfigService } from '../../services/config.service';
import { MatButton } from '@angular/material/button';
import { MatInput } from '@angular/material/input';
import { MatFormField } from '@angular/material/form-field';
import { FlexModule } from '@angular/flex-layout';

@Component({
  selector: 'add-quantifiable-item-dialog',
  templateUrl: './add-quantifiable-item-dialog.component.html',
  styleUrls: ['./add-quantifiable-item-dialog.component.css'],
  providers: [HireItemService],
  standalone: true,
  imports: [
    MatDialogTitle,
    ReactiveFormsModule,
    FormsModule,
    MatDialogContent,
    FlexModule,
    MatFormField,
    MatInput,
    MatDialogActions,
    MatButton
  ]
})
export class AddQuantifiableItemDialogComponent implements OnInit {
  @Input() docketId: number;
  @Input() product: Product;
  @Input() item: Item;
  @Input() quantity: number;

  currentLocation: DepotLocation;
  form: Form;
  offHireDate: moment.Moment;

  constructor(
    public dialogRef: MatDialogRef<AddQuantifiableItemDialogComponent>,
    private configService: ConfigService,
    @Inject(MAT_DIALOG_DATA) public data,
    private hireItemService: HireItemService
  ) {
    if (data.docketId) {
      this.docketId = data.docketId;
    }
    if (data.product) {
      this.product = data.product;
    }
    if (data.quantity) {
      this.quantity = data.quantity;
    }
    if (data.item) {
      this.item = data.item;
    } else {
      this.item = this.product.items[0];
    }
    if (data.lastOffHireEst) {
      this.offHireDate = moment(data.lastOffHireEst);
    }
  }

  ngOnInit() {
    this.configService.currentLocation.subscribe((location) => {
      if (location) {
        this.currentLocation = location;
      }
    });
  }

  submit() {
    const hireItem: any = {
      docket_id: this.docketId,
      hireable_type: 'item',
      hireable_id: this.item.id,
      quantity: this.product.quantifiable ? this.quantity : 1,
      item_quantifiable: this.product.quantifiable,
      on_hire: new Date(),
      estimated_off_hire: this.offHireDate ? this.offHireDate.toDate() : null,
      location_out: this.currentLocation.id
    };
    this.hireItemService
      .create(this.docketId, hireItem)
      .subscribe((newHireItem) => {
        Object.assign(hireItem, newHireItem);
        this.dialogRef.close(hireItem);
      });
  }
}
